var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKebabMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 0C0.795938 0 0 0.795938 0 1.77778C0 2.75962 0.795938 3.55556 1.77778 3.55556C2.75962 3.55556 3.55556 2.75962 3.55556 1.77778C3.55556 0.795938 2.75962 0 1.77778 0ZM1.77778 6.22222C0.795938 6.22222 0 7.01816 0 8C0 8.98184 0.795938 9.77778 1.77778 9.77778C2.75962 9.77778 3.55556 8.98184 3.55556 8C3.55556 7.01816 2.75962 6.22222 1.77778 6.22222ZM1.77778 12.4444C0.795938 12.4444 0 13.2404 0 14.2222C0 15.2041 0.795938 16 1.77778 16C2.75962 16 3.55556 15.2041 3.55556 14.2222C3.55556 13.2404 2.75962 12.4444 1.77778 12.4444Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenu);
export default __webpack_public_path__ + "static/media/kebab-menu.1a7253c2b09e3caca86219839af7cf28.svg";
export { ForwardRef as ReactComponent };